import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { AmplitudeService } from '@app/services/amplitude/amplitude';
import { AuthService } from '@app/services/auth/auth';
import { userActions } from '@app/store/user/user.actions';

export function setUserTokenInitializer(): void {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return;
  }

  const authService = inject(AuthService);
  const user = authService.authUser();

  if (user) {
    inject(Store).dispatch(userActions.setUserToken({ token: user.token }));

    /* Covers the returning-user case (page refresh / reopened browser with an existing session
       cookie) — AuthService.login() only fires for an interactive login/sign-up, not this
       bootstrap-time re-hydration from cookie. */
    inject(AmplitudeService).initAmplitude(user.id.toString());
  }
}
